export const proficienciesText = {
  title: 'PROFICIENCY',
  index: 1,
  contentItems: [
    { label: 'FRONTEND DEVELOPMENT', value: 'INTERMEDIATE' },
    { label: 'BACKEND DEVELOPMENT', value: 'ADVANCED' },
    { label: 'CLOUD DEVELOPMENT', value: 'INTERMEDIATE' },
    { label: 'ML // AI DEVELOPMENT', value: 'NOVICE' },
  ],
};
